import { useState, useMemo } from "react";
import { Switch, Route } from "react-router-dom";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { YearInReviewContainer } from "@ugg/shared/components/YearInReview/YearInReviewContainer";
import { useUserState } from "@ugg/shared/api/requests/accounts/user-state";
import { useLoginState } from "@ugg/shared/hooks/use-user-hooks";
import { SummonerInfo } from "@ugg/shared/hooks/use-is-year-in-review-owner";
import FeedbackForm from "components/Masthead/Feedback/FeedbackForm";

function useSummonerInfoFromUserState(): SummonerInfo | undefined {
  const { data: userState, loading: loadingUserState } = useUserState({ ssr: false });
  const isLoggedIn = useLoginState();

  return useMemo(() => {
    if (!isLoggedIn || !userState || loadingUserState) {
      return undefined;
    }

    const { lolSettings } = userState.getState || {};
    const { summoners } = lolSettings || {};
    const userSummoner = summoners?.[0];

    if (!userSummoner?.verified) {
      return undefined;
    }

    return {
      gameName: userSummoner.riotUserName,
      tagLine: userSummoner.riotTagLine,
      webRegion: userSummoner.regionId,
      isVerified: userSummoner.verified,
    };
  }, [isLoggedIn, userState, loadingUserState]);
}

export function YearInReviewPage() {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const summonerInfo = useSummonerInfoFromUserState();

  const toggleFeedbackPopup = () => {
    setFeedbackOpen(!feedbackOpen);
  };

  return (
    <>
      <Switch>
        <Route
          path={AppRoutes.PROFILE_YEAR_IN_REVIEW}
          render={() => <YearInReviewContainer onContactSupport={toggleFeedbackPopup} summonerInfo={summonerInfo} />}
        />
      </Switch>
      {feedbackOpen && <FeedbackForm toggleFeedbackPopup={toggleFeedbackPopup} />}
    </>
  );
}
